import React from 'react'
import TooltipInputError from '../toolTip/ToolTipInputError'
import { FormControl, TextField } from '@material-ui/core'

function EmailField({
   fieldLabel = 'Correo electrónico *',
   fieldName = 'email',
   formValue,
   fieldInvalid,
   handleChange,
   maxLength = 60,
   error,
   internalErrorMessage = true,
   ...otherProps
}) {
   return (
      <FormControl fullWidth {...otherProps}>
         <TextField
            error={fieldInvalid}
            value={formValue}
            onChange={handleChange}
            type="email"
            inputProps={{ maxLength }}
            InputProps={{
               endAdornment: formValue?.length === maxLength && (
                  <TooltipInputError
                     title={`El número permitido de caracteres es de máximo ${maxLength}.`}
                  />
               )
            }}
            label={fieldLabel}
            name={fieldName}
            helperText={
               internalErrorMessage ?
                 fieldInvalid
                  ? formValue === ''
                     ? 'El campo Correo Electrónico es obligatorio.'
                     : 'Introduzca Dirección de Correo válida.'
                  : ''
               : error
            }
            variant="outlined"
            size="small"
            margin="normal"
            {...otherProps}
         />
      </FormControl>
   )
}

export default EmailField
